import services from '@/services.js'

const handleObject = (dataBalance) => {
  return (
    dataBalance?.channels &&
    Object.entries(dataBalance.channels).map((arr, i) => {
      if (typeof arr[1] == 'object') {
        arr[1].currentBalances.forEach((item, index) => {
          item._typeTable = 'currentBalances'
          item._currentBalanceTemp = 1
          item.index = index
          item._modalTypeValueActive = ''
          item._modalChangeValue = false
          item._modalDelete = false
          item._channel = arr[0]
          item._message = {
            dismissCountDown: false,
            text: '',
            status: '',
          }
        })

        arr[1].recurrentAddOns.forEach((item, index) => {
          item._currentBalanceTemp = 1
          item._typeTable = 'recurrentAddOns'
          item.index = index
          item._modalChangeValue = false
          item._modalDelete = false
          item._channel = arr[0]
          item._message = {
            dismissCountDown: false,
            text: '',
            status: '',
          }
        })

        return {
          channel: arr[0],
          ...arr[1],
        }
      }
    })
  )
}

const handleCurrentBalance = (data) => {
  return Object.entries(data).map((item) => {
    if (item[0] == 'sms') {
      return {
        channel: item[0],
        currentBalance: item[1].currentBalances.length ? item[1].currentBalances.reduce((a, b) => a + b.balance, 0) : 0,
      }
    }

    return {
      channel: item[0],
      currentBalance: item[1].currentBalances.length ? item[1].currentBalances[0].balance : 0,
    }
  })
}

export default {
  getTotalsBalanceChannels: ({ commit }, organizationID) => {
    return new Promise((resolve, reject) => {
      services
        .getCurrentBalanceOrganization(organizationID)
        .then((response) => {
          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getBalances: ({ commit }, { targetOrganizationId, originOrganizationId }) => {
    commit('RESET_BALANCE')
    return new Promise((resolve, reject) => {
      services
        .getBalancesOrganization(targetOrganizationId, { originOrganizationId: originOrganizationId })
        .then((response) => {
          commit('SET_BALANCES', handleObject(response.data.data.target))
          commit('SET_BALANCES_ORIGIN', handleObject(response.data.data.origin))

          commit('SET_CHANNELS_BALANCES', handleCurrentBalance(response.data.data.target.channels || []))
          commit('SET_CHANNELS_BALANCES_ORIGIN', handleCurrentBalance(response.data.data.origin.channels || []))
          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  addRecurring({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let CALL_ENDPOINT = ''
      let BODY = {}

      if (payload.item._channel == 'email') {
        CALL_ENDPOINT = 'postAddOnRecurrentEmail'
        BODY = {
          balance: payload.item.balance,
          reason: payload.item.reason,
          originOrganizationId: payload.originOrganizationId,
        }
      }

      if (payload.item._channel == 'sms') {
        CALL_ENDPOINT = 'postAddOnRecurrentSMS'
        BODY = {
          balance: payload.item.balance,
          reason: payload.item.reason,
          countryId: payload.item.countryId,
          originOrganizationId: payload.originOrganizationId,
        }
      }

      services[CALL_ENDPOINT](payload.organizationId, BODY)
        .then((response) => {
          dispatch('getBalances', { targetOrganizationId: payload.targetOrganizationId, originOrganizationId: payload.originOrganizationId }).then(
            () => {
              resolve(response.data.data.id || response.data.success)
            },
          )
        })
        .catch((error) => {
          reject(error.response.data.message)
        })
    })
  },

  removeRecurring({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let CALL_ENDPOINT = ''

      if (payload.channel == 'email') {
        CALL_ENDPOINT = 'deleteAddOnRecurrentEmail'
      }

      if (payload.channel == 'sms') {
        CALL_ENDPOINT = 'deleteAddOnRecurrentSMS'
      }
      services[CALL_ENDPOINT](payload.organizationId, payload.addOnOrganizationChannelId, { originOrganizationId: payload.originOrganizationId })
        .then((response) => {
          dispatch('getBalances', { targetOrganizationId: payload.targetOrganizationId, originOrganizationId: payload.originOrganizationId }).then(
            () => {
              resolve(response.data.data.id || response.data.success)
            },
          )
        })
        .catch((error) => {
          reject(error.response.data.message)
        })
    })
  },

  updateRecurring: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      let CALL_ENDPOINT = ''
      let BODY = {}

      if (payload.item._channel == 'email') {
        CALL_ENDPOINT = 'patchAddOnRecurrentEmail'
        BODY = {
          balance: payload.item.balance,
          addonId: payload.item.id,
          reason: payload.item.reason,
          originOrganizationId: payload.item.originOrganizationId,
        }
      }

      if (payload.item._channel == 'sms') {
        CALL_ENDPOINT = 'patchAddOnRecurrentSMS'
        BODY = {
          balance: payload.item.balance,
          addonId: payload.item.id,
          countryId: payload.item.countryId,
          reason: payload.item.reason,
          originOrganizationId: payload.item.originOrganizationId,
        }
      }

      services[CALL_ENDPOINT](payload.item.organizationId, BODY)
        .then((response) => {
          dispatch('getBalances', {
            targetOrganizationId: payload.item.targetOrganizationId,
            originOrganizationId: payload.item.originOrganizationId,
          }).then(() => {
            resolve(response.data.data.id || response.data.success)
          })
        })
        .catch((error) => {
          reject(error.response.data.message)
        })
    })
  },

  incrementOrDecrementBalance: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      let CALL_ENDPOINT = ''
      let BODY = {}

      if (payload._channel == 'email') {
        CALL_ENDPOINT = payload._modalTypeValueActive == 'add' ? 'addBalanceEmail' : 'withdrawBalanceEmail'
        BODY = {
          ammount: payload.balance,
          addonId: payload.id,
          reason: payload.reason,
          originOrganizationId: payload.originOrganizationId || null,
        }
      }

      if (payload._channel == 'sms') {
        CALL_ENDPOINT = payload._modalTypeValueActive == 'add' ? 'addBalanceSMS' : 'withdrawBalanceSMS'
        BODY = {
          ammount: payload.balance,
          addonId: payload.id,
          countryId: payload.countryId,
          reason: payload.reason,
          originOrganizationId: payload.originOrganizationId || null,
        }
      }

      services[CALL_ENDPOINT](payload.targetOrganizationId, BODY)
        .then((response) => {
          dispatch('getBalances', { targetOrganizationId: payload.targetOrganizationId, originOrganizationId: payload.originOrganizationId }).then(
            () => {
              resolve(response.data.data.id || response.data.success)
            },
          )
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  removeBalance({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let CALL_ENDPOINT = ''
      let CALL_PARAMS = []

      if (payload.channel == 'email') {
        CALL_ENDPOINT = 'deleteBalanceEmail'
        CALL_PARAMS.push(payload.organizationId)
      }

      if (payload.channel == 'sms') {
        CALL_ENDPOINT = 'deleteBalanceSMS'
        CALL_PARAMS.push(payload.organizationId, payload.countryId)
      }

      services[CALL_ENDPOINT](...CALL_PARAMS, { originOrganizationId: payload.originOrganizationId })
        .then((response) => {
          dispatch('getBalances', { targetOrganizationId: payload.targetOrganizationId, originOrganizationId: payload.originOrganizationId })
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
